import React from 'react';
import SectionLayout from '../layouts/SectionLayout/index';
import FspCarousel from '../FspCurriculumSection/FspCarousel/index';

const SkillSection = React.memo(function SkillSection(props) {
  const { heading, description } = props;

  return (
    <SectionLayout
      heading={
        <span
          className={props.dark ? 'text-v5-neutral-200' : 'text-v5-neutral-600'}
        >
          {heading ? heading : 'Master Data Insights with Key Analytics Tools'}
        </span>
      }
      description={
        description ? (
          description
        ) : (
          <span className={props.dark ? '' : 'text-v5-neutral-500'}>
            Learn 25+ industry-relevant tools across data analytics, data
            science, and AI
          </span>
        )
      }
      {...props}
    >
      <div className="container relative z-[999]">
        <FspCarousel data={props.dreamCompanies} {...props}></FspCarousel>
      </div>
    </SectionLayout>
  );
});

export default SkillSection;
